const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.996 511.996",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M428.225,172.227l-21.213,21.213l47.395,47.395H311.761c-5.333-19.806-20.956-35.429-40.763-40.763V57.427l47.558,47.557  l21.213-21.213L255.998,0l-83.771,83.771l21.213,21.213l47.558-47.557v142.645c-19.806,5.333-35.429,20.956-40.762,40.762H57.589  l47.395-47.395l-21.213-21.213L0,255.998l83.771,83.771l21.213-21.213l-47.722-47.721h142.973  c5.333,19.806,20.956,35.429,40.762,40.762v142.972l-47.558-47.558l-21.213,21.213l83.771,83.771l83.771-83.771l-21.213-21.213  l-47.558,47.558V311.597c19.806-5.333,35.429-20.956,40.762-40.762h142.973l-47.721,47.721l21.213,21.213l83.771-83.771  L428.225,172.227z",
    fill: "#a1abc9",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.4d56a2074a8b90ff81adac71e09c35d4.svg";
export { ForwardRef as ReactComponent };